import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var ThumbsUp = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "thumbs-up",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7 22V11m-5 2v7c0 1.1046.8954 2 2 2h13.4262c1.4808 0 2.74-1.0803 2.9652-2.5438l1.0769-7C21.7479 10.6389 20.3418 9 18.5032 9H15c-.5523 0-1-.4477-1-1V4.4658C14 3.104 12.896 2 11.5342 2a.8218.8218 0 0 0-.7511.4881l-3.5192 7.918A1 1 0 0 1 6.3501 11H4c-1.1046 0-2 .8954-2 2Z"
    })
  }));
};
export default ThumbsUp;